import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converts a Base64 data URL (e.g. from FileReader.readAsDataURL) to a File object.
 * Used for recovering files from localStorage drafts and fallback when native File is invalidated (e.g. after returning from camera on mobile).
 */
export function base64ToFile(base64String: string, fileName: string): File {
  const arr = base64String.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/jpeg';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
}

/**
 * Returns a safe file name for upload. Camera-captured files often have empty/undefined names.
 */
export function getSafeFileName(file: File, fallbackPrefix: string = 'photo'): string {
  return (file.name && file.name !== 'undefined' && file.name !== 'image.jpeg')
    ? file.name
    : `${fallbackPrefix}-${Date.now()}.jpg`;
}
